interface LawyerDescriptionProps {
  introduction: string;
  careerDetails: string[];
  education: string[];
  qualifications: string[];
  performance?: string[];
  observeRef: (node: HTMLElement | null) => void;
}

export function LawyerDescription({
  introduction,
  careerDetails,
  education,
  qualifications,
  performance,
  observeRef,
}: LawyerDescriptionProps) {
  return (
    <div className="px-4 pt-14 pb-[100px] tablet:px-8 desktop:px-0 flex flex-col gap-[73px]">
      <section
        ref={observeRef}
        id="introduction"
        className="scroll-mt-[124px] desktop:scroll-mt-[80px]"
      >
        <p className="whitespace-pre-line text-heading-3-mb desktop:text-heading-3 !font-normal text-[#616269]">
          {introduction}
        </p>
      </section>

      <section
        ref={observeRef}
        id="profile"
        className="scroll-mt-[124px] desktop:scroll-mt-[80px]"
      >
        <h2 className="text-display-2-mb desktop:text-display-2 desktop:font-light text-[#222222]">
          프로필
        </h2>
        <div className="flex flex-col mt-[37px]">
          <ProfileList title="경력" items={careerDetails} />
          {performance && performance.length > 0 && (
            <ProfileList title="실적" items={performance} />
          )}
          <ProfileList title="학력" items={education} />
          <ProfileList title="자격" items={qualifications} />
        </div>
      </section>
    </div>
  );
}

function ProfileList({ title, items }: { title: string; items: string[] }) {
  return (
    <div className="pb-[30px]">
      <h3 className="text-heading-3-mb desktop:text-heading-3 text-[#222222] mb-8">
        {title}
      </h3>
      <ul className="flex flex-col">
        {items.map((item, index) => (
          <li
            key={index}
            className="pb-[10px] flex items-center gap-[9px] desktop:gap-[10px] text-body-2-mb desktop:text-body-2 !font-normal text-[#616269] before:content-[''] before:shrink-0 before:size-[3px] before:bg-c-primary"
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
